export const AppConfig = {
  name: "local",
  production: false,
  environment: 'LOCAL',
  datasServer: '../../../datas/'
};
